module.exports = __webpack_public_path__ + "img/additional_logo.6002f91e.svg";